import { Controller } from "@hotwired/stimulus"

// Submits its element (a CSRF-protected POST form) as soon as it connects, so a
// signed-out developer landing on the sign-in page is sent straight to the
// DoorFlow ID request phase. This restores the old "silent redirect" feel, but
// as a POST carrying a CSRF token rather than the GET that was the login-CSRF
// vector (CVE-2015-9284). The view only attaches this controller when no flash
// is present, so an error bounce-back falls back to the visible button instead
// of looping back into the provider.
export default class extends Controller {
  connect() {
    this.element.requestSubmit()
  }
}
